import { Component } from "@angular/core";
import { UserAccountDisplayNameChangeComponent } from "./forms/user-account-display-name-change.component";
import { UserAccountUsernameChangeComponent } from "./forms/user-account-username-change.component";
import { UserAccountTypeChangeComponent } from "./forms/user-account-type-change.component";
import { UserAccountPrivacyChangeComponent } from "./forms/user-account-privacy-change.component";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { AuthService } from "@ponder-core/auth/auth.service";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { UnauthorizedComponent } from "@ponder-shared/components/unauthorized.component";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { UserSettingsCategory } from "../user-settings-category";
import { RoleAndPermissions } from "@ponder-core/auth/role-permissions";
import { FormatNumberPipe } from "@ponder-shared/pipes/format-number.pipe";
import { UserAccountAvatarChangeComponent } from "./forms/user-account-avatar-change.component";

@Component({
    selector: "user-account-general-settings",
    imports: [
        LoadingComponent,
        UnauthorizedComponent,
        UserAccountAvatarChangeComponent,
        UserAccountDisplayNameChangeComponent,
        UserAccountUsernameChangeComponent,
        UserAccountTypeChangeComponent,
        UserAccountPrivacyChangeComponent,
        FormatNumberPipe
    ],
    templateUrl: "./user-account-general-settings.component.html"
})
export class UserAccountGeneralSettingsComponent {
    public isLoading: boolean = true;
    public authSession?: AuthSession;

    public collectionUniqueLimit: number = 0;
    public deckCountLimit: number = 0;
    
    public constructor(private events: EventBroker, private authService: AuthService) {
        
    }

    public ngOnInit(): void {
        this.events.account.categorySelected.emit(UserSettingsCategory.General);
        
        this.authService.getSessionAsync().then((authSession?: AuthSession) => {
            this.authSession = authSession;
            this.isLoading = false;

            if (this.authSession) {
                this.authService.getRoleAndPermissions().then((roleAndPermissions?: RoleAndPermissions) => {
                    if (roleAndPermissions?.limits) {
                        this.collectionUniqueLimit = roleAndPermissions.limits.uniqueCollectedCount;
                        this.deckCountLimit = roleAndPermissions.limits.deckCount;
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                })
            } else {
                this.isLoading = false;
            }
        });
    }
}